import { useMemo } from "react";

import { MCPFunction } from "@/queries/evals/useListMCPFunctions";

const useMCPFunctionSchema = (
  functions: MCPFunction[] | undefined,
  selectedFunctionName: string | null,
) => {
  // Get schema from current function
  const mcpSchema = useMemo(() => {
    if (functions && selectedFunctionName) {
      const func = functions.find(f => f.name === selectedFunctionName);
      return func?.input_schema;
    }
    return null;
  }, [functions, selectedFunctionName]);

  return {
    mcpSchema,
  };
};

export default useMCPFunctionSchema;
